export default "__VITE_ASSET__b7638c1d__"